/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-argument */

// Personal libs
import { LogEntry } from './logger.interface'
import { AbstractLogManager } from './abstract-logger-manager'

export class LogManager extends AbstractLogManager {
  registerConsoleLogger(): AbstractLogManager {
    if (this.consoleLoggerRegistered) return this

    // Console entries
    this.onLogEntry((logEntry: LogEntry) => {
      this.displayConsoleLog(logEntry)
    })

    this.consoleLoggerRegistered = true
    return this
  }
}

/**
 * Main logger
 */
export const localStorageLogger = (new LogManager())
  .configure()
  .registerConsoleLogger()
  .getLogger()
